import { render, staticRenderFns } from "./add-license.vue?vue&type=template&id=1b7a9f96&"
import script from "./add-license.vue?vue&type=script&lang=js&"
export * from "./add-license.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports